import React from "react";
import ReactDOM from "react-dom";
import { Provider, connect } from "react-redux";

import Toastr from "react-redux-toastr";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";

import {
  ConnectedRouter,
  routerReducer,
  routerMiddleware
} from "react-router-redux";

// import Layout from "./components/Layout/index";
import history from "./utility/history";
import Login from "./components/Login/LoginForm";
import EmailVerification from "./components/EmailVerification/EmailVerification";
import SignUp from "./components/Login/CreateAccount";
import SideNav from "./components/SideBar/SideNav";
import TopNav from "./components/TopNav/TopNav";
import routes from "./routes";
import configureStore from "./store";

//import "./css/custom.css";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";

import CopyRight from "../src/components/CopyRight";
import Session from "./utility/session";
import { login } from "./services/login";

const authUser = {
  isAuthenticated: window.localStorage.getItem(Session.CURRENT_USER_NAME) ? true : false,
  authenticate(cb) {
    if (window.localStorage.getItem(Session.CURRENT_USER_NAME)) this.isAuthenticated = true;
    else this.isAuthenticated = false;
    setTimeout(cb, 100); // fake async
  },
  signout(cb) {
    console.log("Signout");
    this.isAuthenticated = false;
    setTimeout(cb, 100);
  }
};

const store = configureStore();
const ConnectedSwitch = connect(state => ({
  location: state.location
}))(Switch);

const PrivateRoute = ({ component: Component, ...rest }) => (
  <div>
    <div className="container body">
      <div className="main_container">
        <SideNav />
        <TopNav />
        <Route
          {...rest}
          render={props =>
            authUser.isAuthenticated ? (
              <Component {...props} />
            ) : (
              <Redirect
                to={{
                  pathname: "/login?next="+window.location.pathname+window.location.search,
                  state: { from: props.location }
                }}
              />
            )
          }
        />
      </div>

      <CopyRight />
    </div>
  </div>
);

const PublicRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      !authUser.isAuthenticated || ["/subscriptionplans", "/company-profile"].includes(props.match.path) ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/email-verification",
            state: { from: props.location }
          }}
        />
      )
    }
  />
);
ReactDOM.render(
  <Provider store={store}>
    <div className="full-height">
      <Router>
        <Switch>
          {routes.map(
            (route, index) =>
              route.postLogin ? (
                <PrivateRoute
                  path={route.path}
                  key={index}
                  component={route.component}
                />
              ) : (
                <PublicRoute
                  path={route.path}
                  key={index}
                  component={route.component}
                />
                // <Route
                //   path={route.path}
                //   key={index}
                //   component={route.component}
                // />
              )
          )}
          {authUser.isAuthenticated ? (
            <PrivateRoute
              path="/"
              // key={index}
              component={EmailVerification}
            />
          ) : (
            <PublicRoute
              path="/"
              // key={index}
              component={Login}
            />
          )}
        </Switch>
      </Router>
      <Toastr
        timeOut={5000}
        newestOnTop={false}
        preventDuplicates
        position="top-center"
        transitionIn="fadeIn"
        transitionOut="fadeOut"
        progressBar
      />
    </div>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js